export { default } from './Price';

